import script from "./dbClickInput.vue?vue&type=script&setup=true&lang=js"
export * from "./dbClickInput.vue?vue&type=script&setup=true&lang=js"

import "./dbClickInput.vue?vue&type=style&index=0&id=25bca417&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25bca417"]])

export default __exports__